import React, { useId } from 'react';
import { Loader2 } from 'lucide-react';

import { usePurchaseOrderReasonCodesQuery } from 'components/procurement/components/purchaseOrdersV2/queries/PurchaseOrderItemEditQueries';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'shadcn/components/ui/Select';

const labelClassName = 'text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground';

export function ReasonCodePicker({
    disabled = false,
    label = 'Reason Code',
    onValueChange,
    showLabel = true,
    triggerId,
    value = '',
}) {
    const labelId = useId();
    const { data: reasonCodes = [], isFetching, isLoading } = usePurchaseOrderReasonCodesQuery({ enabled: true });

    const showLoading = isLoading || (isFetching && reasonCodes.length === 0);

    if (showLoading) {
        return (
            <div className="flex flex-col gap-2">
                {showLabel && label && (
                    <span id={labelId} className={labelClassName}>
                        {label}
                    </span>
                )}
                <div className="flex h-10 w-full items-center justify-center gap-2 rounded-md border border-input bg-card px-3 text-muted-foreground">
                    <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
                    <span className="text-sm">Loading reason codes…</span>
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-2">
            {showLabel && label && (
                <span id={labelId} className={labelClassName}>
                    {label}
                </span>
            )}
            <Select value={String(value ?? '')} onValueChange={onValueChange} disabled={disabled}>
                <SelectTrigger id={triggerId} className="w-full" aria-labelledby={labelId}>
                    <SelectValue placeholder="Select reason code" />
                </SelectTrigger>
                <SelectContent>
                    {(reasonCodes ?? []).map((code) => (
                        <SelectItem key={code} value={String(code)}>
                            {String(code)}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}

ReasonCodePicker.displayName = 'ReasonCodePicker';
